const FORM_POPUP_SELECTOR = "dialog[data-form-popup]";
const FORM_POPUP_CLOSE_SELECTOR = "button[data-form-popup-close]";
const POPUP_DISMISSED_COOKIE = "popupDismissed=true";
const COOKIE_EXPIRATION_HOURS = 24;

const formPopup = document.querySelector(FORM_POPUP_SELECTOR);
const mediaQuery = window.matchMedia("(max-width: 575px)");

// Function to show/hide popup based on media query
const handlePopupDisplay = (popup, shouldShow) => {
	if (popup) {
		if (shouldShow) {
			popup.inert = true;
			mediaQuery.matches ? popup.showModal() : popup.show();
			popup.inert = false;
		} else {
			popup.close();
		}
	}
};

// Function to set cookie to hide form popup
const setPopupDismissedCookie = () => {
	const now = new Date().getTime();
	const expires = new Date(now + COOKIE_EXPIRATION_HOURS * 60 * 60 * 1000).toUTCString();
	document.cookie = `${POPUP_DISMISSED_COOKIE}; expires=${expires}; path=/`;
};

// Check for cookie immediately on page load
if (document.cookie.includes(POPUP_DISMISSED_COOKIE)) {
	handlePopupDisplay(formPopup, false);
} else {
	if (formPopup) {
		const formPopupClose = formPopup.querySelector(FORM_POPUP_CLOSE_SELECTOR);
	
		const closeFormPopup = () => {
			setPopupDismissedCookie();
			handlePopupDisplay(formPopup, false);
			formPopupClose.removeEventListener("click", closeFormPopup);
		};
	
		formPopupClose.addEventListener("click", closeFormPopup);
		handlePopupDisplay(formPopup, true);
	}
}
